<template>
  <main :class="['bg-white', { 'content-margin': !standalone }]">
    <router-view></router-view>
  </main>
</template>

<script>
export default {
  name: "Content",
  props: {
    standalone: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.content-margin {
  margin-top: 64px;
}
</style>
